import type { WorkbenchView } from "@tutor/live";
import type { FractionAnswer } from "@tutor/ui/widgets";
import { lazy, Suspense } from "react";
import { useT } from "../i18n";
import { AnswerDraftContext } from "../widgets/context";

// The workbench (ADR-0044): a manipulative from Coach beside the exercise, until the
// exercise ends. Where a widget goes is the engine's decision (`canvas.widget`); this only
// draws it. The renderer is the conversation's chunk, loaded on first use.

const WidgetView = lazy(() =>
  import("../widgets/WidgetView").then((module) => ({ default: module.WidgetView })),
);

export function Workbench(props: {
  workbench: WorkbenchView | null;
  itemId: string;
  /** The exercise is done: the workbench goes with it. */
  done: boolean;
  /** The exercise's answer box, for widgets that follow it (a typed item only). */
  answer?: FractionAnswer | null;
}) {
  const t = useT();
  const { workbench, itemId, done, answer = null } = props;
  if (done || workbench?.itemId !== itemId) return null;
  return (
    <section className="workbench" aria-label={t("workbench.label")}>
      <AnswerDraftContext.Provider value={answer}>
        <Suspense fallback={<div className="workbench-loading" aria-busy="true" />}>
          <WidgetView key={workbench.widget.source} block={workbench.widget} />
        </Suspense>
      </AnswerDraftContext.Provider>
    </section>
  );
}
